import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useMembersContext } from '@/contexts/membersContext';
import useMixpanel from '@/hooks/useTracking/useMixpanel';

import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { useMe } from '../../hooks/useMe';

export const AuthenticatedRoot = () => {
  useMe({});
  const { memberData, getMemberFullName } = useMembersContext();

  const mixpanel = useMixpanel();

  useEffect(() => {
    if (memberData?.person?.id) {
      mixpanel.track('User logged in on web', {
        memberName: getMemberFullName(false, false),
        memberEmail: memberData.person.email
      });

      mixpanel.registerSuperProperties({
        memberName: getMemberFullName(false, false),
        memberEmail: memberData.person.email,
        personId: memberData.person?.id || ''
      });
    }
  }, [memberData, mixpanel, getMemberFullName]);

  return (
    <>
      <Header />
      <main className="">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};
